import axiosInstance from "../lib/axiosInstance";

const StateModel=class {

    constructor(){
        this.baseUrl="/adminapi/state/";
    }

    async listCity(query=[])
    {
        return (await axiosInstance.get(`${this.baseUrl}?${new URLSearchParams(query)}`)).data;
    }
    async listState(query=[])
    {
        return (await axiosInstance.get(this.baseUrl)).data;
    }
    async createCity(data=[])
    {
        return await axiosInstance.post(this.baseUrl,data);
    }
    async createState(data=[])
    {
        return await axiosInstance.post(this.baseUrl,data);
    }


    async detailCity(id)
    {
        return (await axiosInstance.get(`${this.baseUrl}${id}`));
    }
    async updateCity(id,data = []) {
        return await axiosInstance.put(`${this.baseUrl}${id}/`, data);
      }
    
    async deleteCity(id)
    {
        return await axiosInstance.delete(`${this.baseUrl}${id}`);
    }

}

export default new StateModel();